/**
 * WISHLIST CREATE
 * 
 * module de gestion des création de wishlist
 * via une popin dans
 * la partie PRO de l'espace mon compte
 */
import $ from "jquery";
import { debounce } from 'throttle-debounce';
import { dialog } from "../../../../components/dialog.js";
const utils = require('../utils.js').default;

const WLCreate = (() => {
    const POPIN_MOVE_PRODUCT_IN_WISHLIST = 'popin-move-product-in-wishlist';
    const DOM_BTN_POPIN_MOVE_PRODUCT_IN_WISHLIST = `[data-js-dialog-open="${POPIN_MOVE_PRODUCT_IN_WISHLIST}"]`;
    const POPIN_CREATE_NEW_WISHLIST = 'popin-create-new-wishlist';
    const DOM_BTN_POPIN_CREATE_NEW_WISHLIST = `.js-wishlist-add-list`;
    const DOM_POPIN_CREATE_NEW_WISHLIST = `[data-js-dialog-id="${POPIN_CREATE_NEW_WISHLIST}"]`;
    const DOM_CREATE_NEW_WISHLIST = '.js-create-new-wishlist';
    const DOM_CREATE_SHOW_FORM = `${DOM_CREATE_NEW_WISHLIST} .js-create-show-form`;
    const DOM_CREATE_FORM = `${DOM_CREATE_NEW_WISHLIST} form`;
    const DOM_CREATE_FIELD = `${DOM_CREATE_FORM} .js-create-wishlist-field`;
    const DOM_CREATE_INPUT = `${DOM_CREATE_FIELD} input`;
    const DOM_CREATE_SUBMIT = `${DOM_CREATE_FORM} .js-create-submit-form`;
    const DOM_ERROR = `${DOM_CREATE_FORM} .error`;
    const DOM_SUCCES = `${DOM_CREATE_FORM} .success`;

    const ERROR_LIST_NAME_TOO_LONG = 'Ce nom de liste est trop long.';
    const ERROR_LIST_NAME_EXIST = 'Ce nom de liste existe déjà.';
    const SUCCESS_LIST_NAME_CREATED = 'Votre liste a bien été créée.';
    
    /**
     * LIST NAME VALIDATION
     * 
     * verification de nouveau nom de liste
     * enabled/disabled du btn submit
     * @param {event} event 
     */
    const listNameValidation = (event) => {
        let input = $(event.currentTarget);
        let listName = utils.slug(input.val());
        let error = false;
        if (listName.length > 1 && listName.length <= 30 && !window.WL.isWishlistExist(listName)) {
            $(DOM_CREATE_SUBMIT).prop('disabled', false);
        } else {
            $(DOM_CREATE_SUBMIT).prop('disabled', true);
        }
        if (listName.length > 30) {
            error = ERROR_LIST_NAME_TOO_LONG;
        } else if (window.WL.isWishlistExist(listName)) {
            error = ERROR_LIST_NAME_EXIST;
        }
        showNotification(error, 'ERROR');
    };
    /**
     * POPIN CLOSE (func)
     * 
     * Fermeture de la popin creation d'adresse
     */
    const popinClose = (event) => {
        $(event.currentTarget).closest('.popin').find('.popin-close').trigger('click');
    };
    /**
     * POPIN OPEN (func)
     * 
     * Ouverture de la popin creation d'adresse
     */
    const popinOpen = () => {
        updateTemplates();
        $(DOM_CREATE_INPUT).off().on('keyup change', debounce(250, function(event) {
            listNameValidation(event);
        }));
        $(DOM_CREATE_SUBMIT).off().on('click', saveListName);
        $(DOM_CREATE_SHOW_FORM).off().on('click', showForm);
        $(DOM_POPIN_CREATE_NEW_WISHLIST).on('click', '.js-create-submit-form', popinClose);
    };
    /**
     * SAVE LIST NAME
     * 
     * sauvegarde de la nouvelle liste
     * @param {event} event 
     */
    const saveListName = (event) => {
        event.preventDefault();
        let input = $(event.currentTarget).closest('form').find('input');
        let listName = input.val();
        window.WL.createWishlist(listName);
        utils.dispatchCustomEvent('MOVE_PRODUCT_IN_WISHLIST_UPDATES', {type: 'all'});
        input.val('');
        // showNotification(SUCCESS_LIST_NAME_CREATED, 'SUCCESS');
        utils.dispatchCustomEvent('NOTIFICATION_DEFAULT', {content: SUCCESS_LIST_NAME_CREATED, type: 'success'});
        // dialog.close();
    };
    /**
     * SHOW NOTIFICATION
     * 
     * affichage des notifications
     * @param {string} notif 
     * @param {string} type 
     */
    const showNotification = (notif, type) => {
        // $(DOM_SUCCES).hide().children().empty();
        $(DOM_CREATE_FIELD).removeClass('c-form__field--error');
        $(DOM_CREATE_FIELD).find('.c-form__error').text('');
        
        if ('ERROR' === type && notif) {
            $(DOM_CREATE_FIELD).addClass('c-form__field--error');
            $(DOM_CREATE_FIELD).find('.c-form__error').text(notif);
            // $(DOM_ERROR).show().children().text(notif);
        } else if ('SUCCESS' === type && notif) {
            // $(DOM_SUCCES).show().children().text(notif);
        }
    };
    /**
     * SHOW FORM
     * 
     * @param {event} event 
     */
    const showForm = (event) => {
        event.preventDefault();
        $(DOM_CREATE_FORM).slideDown();
        $(DOM_CREATE_SHOW_FORM).slideUp('fast');
    };
    /**
     * UPDATE TEMPLATE (func)
     * 
     * Mise à jour du template de la popin 
     * de suppression d'adresse
     */
    const updateTemplates = () => {
        utils.dispatchCustomEvent('TEMPLATE_COMMON_PART', {
            append: false,
            templateId: 'tpl-create-new-wishlist',
            targetElement: DOM_CREATE_NEW_WISHLIST,
            data: {}
        });
    };
    /**
     * INIT (func)
     */
    const init = () => {
        utils.debug('WL CREATE', 'initialisation');   
        $(DOM_BTN_POPIN_MOVE_PRODUCT_IN_WISHLIST).on('click', popinOpen);
        $(DOM_BTN_POPIN_CREATE_NEW_WISHLIST).on('click', popinOpen);
        document.addEventListener('WISHLIST_CREATE_POPIN_OPEN', popinOpen);
    };
    return {init}
})();
export default WLCreate;